import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
   
  },
  mutations: {
    
  },
  actions: {
    // // 获取用户信息接口
    // getInfo({ commit }, $api) {
    //   $api("user", "getUserInfo", {}).then(res => {
    //     commit("updateInfo", res.userAndToken);
    //   });
    // }
  },
  modules: {},
  strict: process.env.NODE_ENV !== "production"
});
